import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, Form, Col, Card, Collapse } from "react-bootstrap";
import { Search, CaretDownFill, CaretUpFill } from "react-bootstrap-icons";
import {  disputeResolutionReducerActions } from "..";

//import styles from "../css/dispute-resolution.module.css";


export function FailedPaymentsSearchForm(props) {



  const dispatch = useDispatch();

  const [showSearch, setShowSearch] = useState(true);

  useEffect(() => {

  }, []);


  const handSearchReset = () => {
    formik.handleReset();
    dispatch(disputeResolutionReducerActions.failedPaymentsSearchReset());
  };


  
  //search form schema definition
  const formikSchema = Yup.object().shape({
    customerMobileNumber: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[0-9]+$/, "Mobile number must contain only digits")
      .min(8, "Mobile number must be at least 8 digits")
      .max(11,"Mobile number must not be greater than 11 digits")
  });

  const initialValue = {
    customerMobileNumber: ""
  }


  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: formikSchema,
    onSubmit: (values, { setSubmitting }) => { //onSubmit 2nd Param is formikBag, inside which setSubmitting is a part of

      props.onFailedPaymentsSearch(values.customerMobileNumber); // sync call

      // Always stop submitting after processing
      setSubmitting(false);
    }
  });

  // clean up function to reset state on component unmount
  useEffect(() => {
    return () => {
      //formik.handleReset();
      dispatch(disputeResolutionReducerActions.failedPaymentsSearchReset());
    };
  }, [dispatch]);
  
  
  
  return (
    <Card>
      <Card.Header>
        <span className="row">
          <span className="fs-4 fs-md-3 fs-lg-2 d-flex align-items-center">
            <h3> <Search size={26} /> {" "} Failed Payments Search </h3>
          </span>
          <span className="col">
            <span
              className="p-0 m-0 d-flex justify-content-end"
            >
              {showSearch
                ? <Button variant="light" onClick={() => { setShowSearch(false) }} > <CaretUpFill size={15} /> </Button>
                : <Button variant="light" onClick={() => { setShowSearch(true) }} > <CaretDownFill size={15} /> </Button>
              }
            </span>
          </span>
        </span>
      </Card.Header>
      <Collapse in={showSearch}>
        <Card.Body>

          <Form noValidate onSubmit={formik.handleSubmit}>
            <Form.Row>
              <Col lg={4} md={6} xs={12}>
                <Form.Group controlId="customerMobileNumber" className="required">
                  <Form.Label>Customer Mobile Number:</Form.Label>
                  <Form.Control
                    name="customerMobileNumber"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.customerMobileNumber}
                    isInvalid={
                      formik.errors.customerMobileNumber && formik.touched.customerMobileNumber 
                    }>
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.customerMobileNumber}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

            </Form.Row>
            <Form.Row>
              <Col lg md={12} sm={12}>
                <Button type="submit" variant="primary" disabled={formik.isSubmitting || !formik.isValid}>
                   <Search /> {" "}
                  Search
                </Button>{" "}
                <Button onClick={() => { handSearchReset() }} variant="secondary">
                  Reset
                </Button>
              </Col>
            </Form.Row>

          </Form>

        </Card.Body>
      </Collapse>
    </Card>
  );
};
